import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// components
import Link, { AnchorStyled } from "core/SiteHeader/components/Link";
export { AnchorStyled };

// styles
import { convertPxToRem } from "frontend/components/helpers";

// data
import { primaryMenu } from "data/links";
const { appsLanding, mac, office, figma, lingo, adobe } =
    primaryMenu.products.links.tools.links;

import { trackHeaderFigmaClicked } from "core/trackEvent";

// styles
export const LinkStyled = styled(Link)`
    display: block;
    margin: 0px;

    ${AnchorStyled} {
        font-size: ${convertPxToRem(13)};
        color: ${({ $linkColor }) => $linkColor};
        border-bottom-color: ${({ $linkColor }) => $linkColor};

        &:hover {
            color: ${({ $linkHoverColor }) => $linkHoverColor};
            border-bottom-color: ${({ $linkHoverColor }) => $linkHoverColor};
        }
    }
`;

// component
export const ToolsMenu = ({ className, linkColor, linkHoverColor }) => {
    const { isDarkMode } = useSiteHeader();
    return (
        <ul className={className}>
            <LinkStyled
                $isDarkMode={isDarkMode}
                $linkColor={linkColor}
                $linkHoverColor={linkHoverColor}
                link={appsLanding}
            />
            <LinkStyled
                $isDarkMode={isDarkMode}
                $linkColor={linkColor}
                $linkHoverColor={linkHoverColor}
                link={figma}
                onClick={() => {
                    trackHeaderFigmaClicked();
                }}
            />
            <LinkStyled
                $isDarkMode={isDarkMode}
                $linkColor={linkColor}
                $linkHoverColor={linkHoverColor}
                link={office}
            />
            <LinkStyled
                $isDarkMode={isDarkMode}
                $linkColor={linkColor}
                $linkHoverColor={linkHoverColor}
                link={mac}
            />
            <LinkStyled
                $isDarkMode={isDarkMode}
                $linkColor={linkColor}
                $linkHoverColor={linkHoverColor}
                link={adobe}
            />
            <LinkStyled
                $isDarkMode={isDarkMode}
                $linkColor={linkColor}
                $linkHoverColor={linkHoverColor}
                link={lingo}
            />
        </ul>
    );
};

export default ToolsMenu;

// prop-types
ToolsMenu.propTypes = {
    className: PropTypes.string,
    linkColor: PropTypes.string.isRequired,
    linkHoverColor: PropTypes.string.isRequired,
};
